export default __webpack_public_path__ + "static/media/performance.4a3b5924.png";